<template>
  <reg-card center>
    <div class="check-icon">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ff825d" stroke-width="2.5">
        <path d="M20 6 9 17l-5-5"/>
      </svg>
    </div>
    <p class="eyebrow">CONFIRMAÇÃO</p>
    <h2 class="title">Parabéns, a sua conta está ativa!</h2>
    <p class="sub">De seguida pode adicionar um novo restaurante na dashboard e começar a otimizar o seu negócio.</p>
    <button class="btn-dark" @click="$emit('done')">AVANÇAR</button>
  </reg-card>
</template>

<script>
import RegCard from "../components/RegCard.vue";
export default {
  name: "RegStep3",
  components: { RegCard },
};
</script>

<style scoped lang="scss">
.check-icon { width: 64px; height: 64px; border-radius: 50%; border: 2.5px solid #ff825d; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; }
.eyebrow { font-size: 10px; font-weight: 700; letter-spacing: .12em; color: #b0a8a0; text-transform: uppercase; margin-bottom: 6px; }
.title   { font-size: 22px; font-weight: 800; color: #1a1210; margin-bottom: 12px; }
.sub     { font-size: 13.5px; color: #7a736e; margin-bottom: 20px; line-height: 1.5; }
.btn-dark { display: flex; align-items: center; justify-content: center; width: 100%; height: 50px; border: none; border-radius: 10px; background: #1a1210; color: #fff; font-size: 14px; font-weight: 700; cursor: pointer; font-family: inherit; &:hover { background: #2d2420; } }
</style>
